import { get } from "lodash";
import { getUser } from "./users";

export const getNoteAuthor = async (note) => {
  let author;
  if (note.updated_by) {
    try {
      author = await getUser(note.updated_by);
      author = `${get(author, ["profile", "firstname"])} ${get(author, [
        "profile",
        "lastname",
      ])}`;
    } catch (e) {
      console.log(e);
      author = "";
    }
  } else {
    author = "";
  }
  return author;
};
